module.exports = __webpack_public_path__ + "img/add-big-button-icon.a54f6f7c.svg";